import React, { useEffect, useState } from 'react';
import { InputContainer } from '../form/input/containers/input.container';
import { InputLabelContainer } from '../form/label/containers/input-label.container';
import storePersist from '../../../redux/storePersist';
import { useAppDispatch } from '../../../hooks/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { tenantDetails } from '../../../request/request';
import { guestToken, loginWithPin } from '../../../redux/auth/actions';
import { toast } from 'react-toastify';
import moment from 'moment';
import { getHostName, getOrigin } from '../../services/common.service';
import { router } from '../../../redux/router/action';

export function ServicePINContainer () {

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {state} = useLocation();
  // const {tenant} = state;
  const tenant = localStorage.getItem("tenantName")
  const companyName = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.CompanyName;
 
  const [ selectPinValues, setSelectPinValues ] = useState<any>()
 
  const handlePIN: any = (event: any, field: string) => {
    setSelectPinValues({ ...selectPinValues, [field]: event });
  }

  const handleLogout = () => {
		localStorage.removeItem('token')
		localStorage.removeItem('accessToken')
		localStorage.removeItem('tokenData')
		localStorage.removeItem('userProfile')
        var channelsList = storePersist?.get("channels")?.current;

			const specificChannel = channelsList?.items?.find(
			  (element:any) => element.SalesChannelName === "Service"
			);
			tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
			tenantDetails.StoreId = specificChannel?.StoreId;
			tenantDetails.SalesChannelId = specificChannel?.Id;
		
	}

  const handleSubmit = async () => {
    // await dispatch(guestToken({
		// 	loginData: [
		// 		{
		// 			"Context": {
		// 				"domain": "string",
		// 				"core_version": "string",
		// 				"bap_id": "knparises.digiit.io",
		// 				"bap_uri": "https://knparises.csp.digiit.io",
		// 				"bpp_id": "string",
		// 				"bpp_uri": "string",
		// 				"city": "string",
		// 				"country": "string",
		// 				"action": "string",
		// 				"transaction_id": "string",
		// 				"message_id": "string",
		// 				"timestamp": moment.utc(),
		// 				"ttl": "string",
		// 				"Subscription": "UCP",
		// 				"Domain": "Fusionnet",
		// 				"SubDomains": [
							
		// 				],
		// 				"Network": "Internal",
		// 				"Application": "Platform",
		// 				"Channel": "CSP"
		// 			},
		// 			"Message": {
		// 				"AccountType": "Internal"
		// 			}
		// 		}
		// 	]
		// }));
    try{
      const response = await dispatch(loginWithPin({
        loginData:{
          Records: [
            {
              Context:{},
              Message: {
                ...selectPinValues
              }
            }
          ]
      }})) 
      // console.log('loginWithPin response', response)
      // window.open(`https://${tenant}/service/catalog/products`);
      await dispatch(router.setServiceApplication({
        serviceApplication: 'Internal'
      }))
      await dispatch(router.setIsServiceAuthenticated({
        isServiceAuthenticated: 'true'
      }))
      window.location.href = `https://${tenant}/service/catalog/products`

    } catch (e){
      await dispatch(router.setServiceApplication({
        serviceApplication: 'Internal'
      }))
      await dispatch(router.setIsServiceAuthenticated({
        isServiceAuthenticated: 'false'
      }))
      window.location.href = "/service/auth/login/pin"
      // navigate('/csg-portal/service/auth/login/pin', {state: {tenant: tenant}})
      toast.error('Access couldn\'t be granted. Contact support!' );
    }
    
  }

  useEffect(() => {
    handleLogout();
  }, []);


  return (
   <>
   <div className="flex flex-col p-5 ">
      <div className="flex flex-row items-center justify-around space-x-4">
        <div className="m-20 bg-cover bg-center bg-white shadow-2xl rounded-xl p-10">
          <form>
            <div className="p-4 text-center">
              <p className="text-lime-600 font-bold uppercase text-xl">
              {tenant}
              </p>
              </div>
              <div className="text-center text-sm p-4">
              <InputLabelContainer
                label="Login With Pin"
              />
            </div>
            <InputContainer
              name="scpPIN"
              onValueChange={(event: any) => {
                handlePIN(
                  event.target.value,
                  'scpPIN',
                  selectPinValues?.scpPIN
                )
              }}
              placeholder="Enter The PIN"
              type="text"
              value={selectPinValues?.scpPIN}
             />
        
            <button
              onClick={handleSubmit}
              type="button"
              className="w-full hover:bg-black-800 cursor-pointer bg-black text-white rounded font-medium px-4 py-2 "
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
   </>
  )
}
